export default "/images/framework/SaveAvatarEng.b2de38c7.svg?b2de38c7";